export default __webpack_public_path__ + "static/MRF-nav-5bf785462fdf47e3129cdf5daf0f8a6d.png";